import LightClientApi, { DefineApiRoutes } from '@openclassrooms/sdk';
import type { ClientApi } from '@openclassrooms/sdk-web';
import type OCAISDK from '@openclassrooms/js-ai-sdk';

// TODO: use generated types from OpenAPI here
type ApiRoutes = DefineApiRoutes<{
  '/me': {
    GET: {
      response: {
        id: number;
        email: string;
        firstName: string;
        lastName: string;
        roles: string[];
      };
    };
  };
  '/courses': {
    POST: {
      body: {
        title: string;
        description: string;
      };
      response: {
        id: number;
        title: string;
        description: string;
      };
    };
  };
  '/courses/:id': {
    GET: {
      routeParams: {
        id: number;
      };
      response: {
        id: number;
        title: string;
        description: string;
      };
    };
    PUT: {
      routeParams: {
        id: number;
      };
      body: {
        title: string;
        description: string;
      };
      response: {
        id: number;
        title: string;
        description: string;
      };
    };
    PATCH: {
      routeParams: {
        id: number;
      };
      body: {
        title?: string;
        description?: string;
      };
      response: {
        id: number;
        title: string;
        description: string;
      };
    };
    DELETE: {
      routeParams: {
        id: number;
      };
    };
  };
}>;

export default (() => {
  let ocClient: ClientApi | null = null;
  let lightOcClient: LightClientApi<ApiRoutes> | null = null;
  let aiClient: OCAISDK | null = null;

  return {
    setOCClient(newClient: ClientApi) {
      ocClient = newClient;
    },
    getOCClient(): ClientApi {
      // istanbul ignore next
      if (!ocClient) {
        throw new ReferenceError(
          '[data-connect-web] calling getOCClient() but no client has been set: did you forget to call setOCClient()?'
        );
      }

      return ocClient;
    },

    setLightOCClient(newClient: LightClientApi<ApiRoutes>) {
      lightOcClient = newClient;
    },
    getLightOCClient(): LightClientApi<ApiRoutes> {
      // istanbul ignore next
      if (!lightOcClient) {
        throw new ReferenceError(
          '[data-connect-web] calling getLightOCClient() but no client has been set: did you forget to call setLightOCClient()?'
        );
      }

      return lightOcClient;
    },

    setAIClient(newClient: OCAISDK) {
      aiClient = newClient;
    },

    getAIClient(): OCAISDK {
      // istanbul ignore next
      if (!aiClient) {
        throw new ReferenceError(
          '[data-connect-web] calling getAIClient() but no client has been set: did you forget to call setAIClient()?'
        );
      }

      return aiClient;
    },
  };
})();
